module.exports = __webpack_public_path__ + "static/media/r202.803be3cb.jpg";